import moment from 'moment'
import Select from 'react-select'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { DatePicker, Dropdown } from 'antd'
import { Link, Route, Switch, useHistory } from 'react-router-dom'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet, useSocketEvents, presets } from '../../modules'

import Receive from '../reusable/receive'
import Patient from '../reusable/patient'
import Confirm from '../reusable/confirm'
import QueueEntry from '../reusable/queueEntry'

import Requests from '../drawers/requests'
import { FaHandHolding } from 'react-icons/fa'
import PatientDetails from '../drawers/patient'
import AttachedDoc from '../drawers/attachedDocument'
import ConsutationDrawer from '../drawers/consultation'

const { RangePicker } = DatePicker

const Consultation = ({
    category,
    specialty,
    requestDepartment = 'Consultation',
    notificationDestination = 'Doctor',
    path,
}) => {
    const [cId, setCId] = useState()
    const [string, setString] = useState('')
    const [ent, setEnt] = useState()
    const [chosen, setChosen] = useState([])
    const [attachedDoc, setAttachedDoc] = useState()
    const [sIString, setSIString] = useState('')
    const [pendingForwards, setFCount] = useState(0)
    const [type, setType] = useState({ label: 'All', value: 'All' })
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])

    const history = useHistory()

    const [select, toggleSelect] = useToggle()
    const [notSeen, toggleNSeen] = useToggle(true)

    const { user } = useSelector(state => state.application)

    const [
        { loading: qLoading, error: qError, fetch: fetchQueue },
        { list: queue },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('doctorsQueue', ranges ? {
        string,
        pendingOnly: notSeen,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null,
        type: !category && !specialty && type?.value !== 'All' ? type?.value : undefined,
        category,
        specialty,
        order: notSeen ? 1 : -1,
    } : {
        string,
        pendingOnly: notSeen,
        type: !category && !specialty && type?.value !== 'All' ? type?.value : undefined,
        category,
        specialty,
        order: notSeen ? 1 : -1
    }, { notify: true }, 'entries')

    const [, getFCount] = usePet('forwards', { destination: "Doctor", pending: true }, { notify: true, callback: ({ data }) => setFCount(data.count) })

    const [
        { loading: sILoading, error: sIError },
        { list: saleItems = [] }
    ] = useListData('pointOfSaleItems', { category: 'Doctor', string: sIString }, { notify: true, manual: !!category }, 'items', 50)

    const [
        { loading: dLoading, error: dError },
        { list: documents = [] }
    ] = useListData('pointOfSaleItems', { category: 'Documents' }, { notify: true }, 'items', 50)

    const onComplete = ({ data }) => history.push(`${path}/attached/${attachedDoc.toLowerCase().replaceAll(' ', '-')}/${data._id}`)

    const [, createAttachedDocument] = usePet('createAttachedDocument', {
        attachedTo: ent?.ref?._id,
        patient: ent?.ref?.patient?._id,
        name: attachedDoc,
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Attaching document...' } })

    const createAttachedDoc = (entry, doc) => {
        setEnt(entry)
        setAttachedDoc(doc)
        Confirm({
            title: `Attach ${doc}`,
            message: `Attach ${doc} for ${entry?.ref?.patient?.name}?`,
            onOk: createAttachedDocument,
            okText: 'Proceed'
        })
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        getFCount()
        fetchQueue()
    }

    let callback = (_, notify, ops) => {
        refresh()
        notify('Changes have been saved', ops('success'))
    }

    const [, toggleSeen] = usePet('toggleSeenStatus', {
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } })

    const [, toggleDiscard] = usePet('toggleDiscardStatus', {
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } })

    useSocketEvents({
        'new-patient': {
            condition: data => data.destination === notificationDestination,
            notif: {
                message: 'New Patient',
                type: 'info'
            },
            callback: refresh
        }
    })

    const filterByType = typ => {
        setType(typ)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const toggleNotSeen = () => {
        toggleNSeen()
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker value={ranges} onChange={selectRange} ranges={presets} />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">Patients' Queue</h2>
                        <span>
                            <input
                                onChange={toggleNotSeen}
                                checked={notSeen}
                                type="checkbox"
                                className="form-checkbox cursor-pointer h-5 w-5" />
                            <span className="text-gray-500 text-xs italic ml-2">Only Show Pending</span>
                        </span>
                    </span>
                    <span className="flex items-center justify-between">
                        {
                            !(category || specialty) &&
                            <Receive
                                loading={sILoading}
                                error={sIError}>
                                <Select
                                    value={type}
                                    onChange={filterByType}
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={[{ label: 'All', value: 'All' }, ...saleItems.map(item => ({ label: item.name, value: item._id }))]}
                                    placeholder="Filter By Type" />
                            </Receive>
                        }
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        <Link className="ml-2" to={`${path}/requests`}>
                            <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                <FaHandHolding />
                                <span className="xs:block ml-2">Requests</span>
                            </button>
                        </Link>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={qLoading}
                        error={qError}>
                        {
                            queue?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Paid For</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date of Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                queue.map((entry, key) =>
                                                    <QueueEntry entry={entry}>
                                                        {
                                                            (called, engaged, callPatient, loading) =>
                                                                <tr>
                                                                    <td className="p-2">
                                                                        <div className="text-center">
                                                                            {
                                                                                select ?
                                                                                    <input
                                                                                        onChange={() => choose(entry._id)}
                                                                                        checked={chosen.includes(entry._id)}
                                                                                        type="checkbox"
                                                                                        className="form-checkbox cursor-pointer h-5 w-5" />
                                                                                    :
                                                                                    `${((page - 1) * limit) + (key + 1)}.`
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <Patient patient={entry?.ref?.patient} />
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="text-left">{entry.item?.name ?? entry.ref.name}</div>
                                                                        <div className="flex space-x-2 pl-1 items-center">
                                                                            <div className={`w-2 h-2 rounded-full bg-${(called || engaged) ? 'blue' : entry.filled ? 'green' : entry.discarded ? 'grey' : 'yellow'}-500 shadow`}></div>
                                                                            <p className={`text-${(called || engaged) ? 'blue' : entry.filled ? 'green' : entry.discarded ? 'grey' : 'yellow'}-500 text-xs italic mb-0`}>{called ? `Has just been called to ${called}` : engaged ? `Currently being seen at ${engaged}` : entry.filled ? `Seen By ${entry?.filledBy?.name}` : entry.discarded ? 'Discarded' : 'Pending'}</p>
                                                                        </div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="text-center">{stringifyDate(entry.date)}</div>
                                                                    </td>
                                                                    <td className="p-2 text-center">
                                                                        <Dropdown menu={{ items: [
                                                                            {
                                                                                key: '1',
                                                                                label: `${entry.filled ? 'Review' : 'See'} Patient`,
                                                                                onClick: () => history.push(`${path}/${entry._id}`)
                                                                            },
                                                                            {
                                                                                key: '2',
                                                                                label: 'Patient Details',
                                                                                onClick: () => history.push(`${path}/patients/${entry?.ref?.patient?._id}`)
                                                                            },
                                                                            {
                                                                                key: '3',
                                                                                label: 'Call For Patient',
                                                                                onClick: callPatient,
                                                                                disabled: !(!(called || engaged) || loading)
                                                                            },
                                                                            {
                                                                                key: '4',
                                                                                label: 'Attach Document',
                                                                                children: documents.map((doc, i) => ({
                                                                                    key: `4-${i}`,
                                                                                    label: doc.name,
                                                                                    onClick: () => createAttachedDoc(entry, doc.name)
                                                                                }))
                                                                            },
                                                                            {
                                                                                key: '5',
                                                                                label: entry?.discarded ? 'Restore Request' : 'Discard Request',
                                                                                onClick: () => {
                                                                                    setCId(entry?._id)
                                                                                    Confirm({
                                                                                        title: entry?.discarded ? 'Restore This Request' : 'Discard This Request',
                                                                                        message: entry?.discarded ? 'This will undo the discard action applied to this request' : 'This will discard this item from the pending queue',
                                                                                        okText: entry?.discarded ? 'Restore Request' : 'Discard Request',
                                                                                        onOk: toggleDiscard
                                                                                    })
                                                                                }
                                                                            },
                                                                            {
                                                                                key: '6',
                                                                                label: entry?.filled ? 'Mark Incomplete' : 'Mark Completed',
                                                                                disabled: !(user?.issuperuser || !entry?.filled),
                                                                                onClick: () => {
                                                                                    setCId(entry?._id)
                                                                                    Confirm({
                                                                                        title: entry?.filled ? 'Mark as Incomplete' : 'Mark as Completed',
                                                                                        message: `This will mark this request as ${ entry?.filled ? 'incomplete' : 'complete' }`,
                                                                                        okText: entry?.filled ? 'Mark Incomplete' : 'Mark Completed',
                                                                                        onOk: toggleSeen
                                                                                    })
                                                                                }
                                                                            }
                                                                        ]}}>
                                                                            <button type="button" className="ant-dropdown-link flex items-center h-10">
                                                                                <span className="mr-2">Actions</span> <AiOutlineDown />
                                                                            </button>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                        }
                                                    </QueueEntry>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No patients {string.trim().length > 2 ? `matching "${string}"` : ""} were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path={`${path}/patients/:id`}>
                    <PatientDetails reload={refresh} source={path} />
                </Route>
                <Route path={`${path}/requests`}>
                    <Requests department={requestDepartment} path={path} />
                </Route>
                <Route path={`${path}/attached/:name/:id`}>
                    <AttachedDoc name={ attachedDoc } />
                </Route>
                <Route path={`${path}/:id`}>
                    <ConsutationDrawer path={path} onClose={refresh} />
                </Route>
            </Switch>
        </div>
    )
}

export default Consultation
